import { request } from 'graphql-request';
import { API_URL, APP_DOMAIN } from 'appenv';

const confirmationEmailResendMutation = `
  mutation confirmationEmailResend($eventDomain: String!, $email: String!) {
    confirmationEmailResend(input: {
      eventDomain: $eventDomain,
      email: $email
    }) {
      success
    }
  }
`;

function confirmationEmailResend(email) {
  return request(API_URL, confirmationEmailResendMutation, {
    eventDomain: APP_DOMAIN,
    email,
  }).then((result) => result.confirmationEmailResend).catch(() => ({ success: false }));
}

export default confirmationEmailResend;
